import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GopherService } from '../gopher.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.less']
})
export class ResultComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router,
    private gopherService: GopherService, private toastr: ToastrService, private formBuilder: FormBuilder) { }

  currUser;
  collectionSize: any;
  page: number = 1;
  previousPage: any;
  pageSize: number = 15;
  attackLists;
  resultSearchForm:FormGroup;

  ngOnInit() {
    this.currUser = JSON.parse(localStorage.getItem('user'));
    if (!this.currUser.gopherAdmin) {
      this.router.navigate(['home']);
    }
    this.setresultSearchForm();
    this.route.queryParams.subscribe(() => {
      this.getAttackResults();
    })
    
  }

  getAttackResults() {
    let searchParams = this.route.snapshot.queryParams;
    console.log(searchParams,'sp');
    this.gopherService.getAttackresults(searchParams).pipe().subscribe(data => {
      if (data.code === 200) {
        this.attackLists = data.response;
        this.page = searchParams.page;
        this.collectionSize = data.response.count;
      } else {
        this.collectionSize = 0;
        this.page = 1;
      }
    });
  }

  setresultSearchForm() {
    this.resultSearchForm = this.formBuilder.group({
      projectIds: [],
      executedBy: null,
      executionStatus: null,
      fromDate: null,
      toDate: null
    });
  }


  pagination(): void {
    let searchParams = this.resultSearchForm.value;
    let collection = {
      page: this.page || 1,
      size: this.pageSize || 15
    };
    searchParams = { ...collection, ...searchParams };
    console.log(searchParams);

    this.router.navigate(['.'], { relativeTo: this.route, queryParams: searchParams });
  }

  onPageChange(page: number): void {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.pagination();
    }
  }

  onSizeChange(size: number): void {
    this.pageSize = size;
    this.pagination();
  }

}
